module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Chat#1-9273bb3a256f9318851a7b9d0ba3a9a3.svg";